import boys1 from "../images/boysGallery/boys1.jpg";
import boys2 from "../images/boysGallery/boys2.jpg";
import boys3 from "../images/boysGallery/boys3.jpg";
import boys4 from "../images/boysGallery/boys4.jpg";
import boys5 from "../images/boysGallery/boys5.jpg";
import boys6 from "../images/boysGallery/boys6.jpg";
import boys7 from "../images/boysGallery/boys7.jpg";
import boys8 from "../images/boysGallery/boys8.jpg";
export const boysData = [
  {
    image: boys1,
  },
  {
    image: boys2,
  },
  {
    image: boys3,
  },
  {
    image: boys4,
  },
  {
    image: boys5,
  },
  {
    image: boys6,
  },
  {
    image: boys7,
  },
  {
    image: boys8,
  },
];
